import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD_HqEsGfQHR6S6vygF2w9SfqXEZV3hYTE",
  authDomain: "oneandall-dev-9513d.firebaseapp.com",
  databaseURL: "https://oneandall-dev-9513d.firebaseio.com",
  projectId: "oneandall-dev-9513d",
  storageBucket: "oneandall-dev-9513d.appspot.com",
  messagingSenderId: "343009836525",
  appId: "1:343009836525:web:182f51e4adebc7d5a6fbe4"
};

firebase.initializeApp(firebaseConfig).functions("europe.west1");

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const functions = firebase.app().functions("europe-west1");

export { db, auth, storage, functions };
